import cx from 'classnames'

type Props = {
  text: string
  'data-testid'?: string
  className?: string
  children?: React.ReactNode
  icons?: React.ReactNode
}

const RightPanelHeader = ({
  text,
  'data-testid': dataTestId,
  className,
  children,
  icons,
}: Props) => {
  return (
    <div className={cx('flex flex-row items-center w-full', className)}>
      <h4
        data-testid={dataTestId}
        aria-level={1}
        className="text-2xl text-base-700 font-relais"
      >
        {text}
      </h4>
      {children}
      <div className="flex gap-2 ml-auto">{icons}</div>
    </div>
  )
}

export default RightPanelHeader
